const AdminView = () => import('./views/AdminView');
const GameView = () => import('./views/GameView');
const SessionView = () => import('./views/SessionView');
const QuizSessionView = () => import('./views/QuizSessionView');
const PodiumView = () => import('./views/PodiumView');

export default [
    {
        path: '/memoransier/admin',
        component: AdminView
    },
    {
        path: '/memoransier/game/:gameId',
        props: true,
        name: 'MemoransierGameView',
        component: GameView
    },
    {
        path: '/memoransier/game/:gameId/session',
        props: true,
        name: 'MemoransierSessionView',
        component: SessionView
    },
    {
        path: '/memoransier/game/:gameId/quiz-session',
        props: true,
        name: 'MemoransierSessionQuizView',
        component: QuizSessionView
    },
    {
        path: '/memoransier/game/:gameId/podium',
        props: true,
        name: 'MemoransierPodiumView',
        component: PodiumView
    }
];
